import {lazy} from "react";

const FolderHome = lazy(() => import("./FolderHome"));

const folderRoutes = [
    {
        path: "/folder/:id",
        element: <FolderHome/>,
    },
];

export default folderRoutes;